//入库计划单

export default [

    {   //头程物流列表
        path: "headlogitics/list",
        name: "headlogiticsList",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/headlogistics/index"),
    },

    {   //头程编辑页，查看
        path: "headlogitics/update/:type",
        name: "headlogiticsUpdate",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/headlogistics/update/index"),
    },
    {   // 创建头程
        path: "headlogitics/create/:type",
        name: "createheadlogistics",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/headlogistics/logistics"),
    },
    {   //头程物流货代端列表
        path: "headlogitics/forwarder/list",
        name: "headlogiticsListForwarder",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/headlogistics/forwarder/index"),
    },

    {   //头程编辑页，查看
        path: "headlogitics/forwarder/update/:type",
        name: "headlogiticsUpdateForwarder",
        component: () => import(/* webpackChunkName: "headlogitics" */ "@/views/headlogistics/update/index"),
    },
]


